<div class="container-fluid pb-3 pt-2">
  <h4 class="mb-2">{{headingText}}</h4>
  <div *ngIf="!loading; else loader">
    <form *ngIf="form" [formGroup]="form" class="filters">
      <mat-form-field>
        <mat-label>Agenzia</mat-label>
        <agenzia-picker formControlName="agenzia"></agenzia-picker>
      </mat-form-field>

      <mat-form-field>
        <mat-label>Incaricato</mat-label>
        <user-picker formControlName="incaricato"></user-picker>
      </mat-form-field>
    </form>

    <resourceful-index #index [search]="search" [modelService]="preferenzaAgenziaService" [deleteFunction]="deleteFunction"
      [columnDefinitions]="columnDefinitions" [editFunction]="editFunction" [selectionMode]="selectionMode"
      (selectedModel)="closeDialogWithSelectedModel($event)" [relations]="relations">
    </resourceful-index>

    <button mat-raised-button color="primary" class="mt-4" (click)="add()">
      Aggiungi preferenza<mat-icon>add</mat-icon>
    </button>

  </div>
  <ng-template #loader>
    <mat-spinner></mat-spinner>
  </ng-template>
</div>
